import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../../configs/api";
import ProjectDetailsCard from "../../../components/public/userProjectDetails/ProjectDetailsCard";
import ProjectAboutLacasa from "../../../components/public/userProjectDetails/ProjectAboutLacasa";
import FloorPlan from "../../../components/public/userProjectDetails/FloorPlan";
import AmenitiesProject from "../../../components/public/userProjectDetails/AmenitiesProject";
import Brochure from "../../../components/public/userProjectDetails/Brochure";
import Specification from "../../../components/public/userProjectDetails/Specification";
import PaymentSchedule from "../../../components/public/userProjectDetails/PaymentSchedule";
import ProjectFacilities from "../../../components/public/userProjectDetails/ProjectFacilities";
import ContactForm from "../../../components/public/userCommon/ContactForm";
import { useViewLogger } from "../../../hooks/useAnalyticsTracker";
import { MapEmbed } from "../../../components/admin/common/details-components";
import { formatPrettyAddress } from "../../../utils/helpers";

const DetailsProjectProperty = () => {
  const { id } = useParams();
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { trackView } = useViewLogger(id, false);

  useEffect(() => {
    trackView();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Fetch project data by ID
  const fetchProjectById = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/properties/${id}`);
      // console.log("project data:", response?.data?.data);
      if (response.data?.data) {
        if (response.data.data.type !== "project") {
          setError("This property is not a project type.");
          return;
        }
        setProjectData(response.data.data);
      } else {
        setError("Project data not found.");
      }
    } catch (err) {
      console.error("Error fetching project details:", err);
      setError("Failed to fetch project details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchProjectById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Handle loading state
  if (loading) {
    return (
      <div className="flex  justify-center items-center min-h-screen text-gray-600">
        Loading project details...
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <ProjectDetailsCard projectData={projectData} />

      <div className="grid grid-cols-1 lg:grid-cols-4 px-4 sm:px-6 lg:px-8 xl:px-10 lg:gap-8">
        <div className="col-span-3 space-y-6 md:space-y-8 pb-6 md:pb-8 lg:pb-10">
          <ProjectAboutLacasa
            description={projectData.description}
            builderName={projectData.property?.builderName}
          />
          <FloorPlan floorPlan={projectData.property?.floorPlan} />
          <AmenitiesProject amenities={projectData.property?.amenities || []} />
          <Brochure brochureUrl={projectData.property?.brochureUrl} />
          <MapEmbed
            className="h-[30rem]"
            coordinates={projectData?.location?.coordinates}
            address={formatPrettyAddress(projectData?.location)}
          />
          <Specification
            specification={projectData.property?.specification || []}
          />
          <PaymentSchedule
            paymentSchedule={projectData?.property?.paymentSchedule}
          />
          <ProjectFacilities
            facilities={projectData.property?.facilities || []}
          />
        </div>
        <div className="lg:col-span-1 w-full pb-8">
          <ContactForm
            propertyId={projectData._id}
            propertyTitle={projectData.title}
            listedBy={projectData.listedBy}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsProjectProperty;
